module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n  var i18n = require(\'@cdo/netsim/locale\');\n  var NetSimConstants = require(\'./NetSimConstants\');\n  var NetSimUtils = require(\'./NetSimUtils\');\n  var Packet = require(\'./Packet\');\n\n  var EncodingType = NetSimConstants.EncodingType;\n  var MessageGranularity = NetSimConstants.MessageGranularity;\n  var PacketUIColumnType = NetSimConstants.PacketUIColumnType;\n\n  var getEncodingLabel = NetSimUtils.getEncodingLabel;\n  var forEachEnumValue = NetSimUtils.forEachEnumValue;\n\n  /**\n  * @name enabledEncodingsHash\n  * @type {Object}\n  */\n\n  function isEncodingEnabled(queryEncoding) {\n    return locals.enabledEncodingsHash[queryEncoding] === true;\n  }\n\n  /** @type {Packet.HeaderType[]} */\n  var headerFields = locals.packetSpec;\n\n  /** @type {boolean} */\n  var showToAddress = headerFields.indexOf(Packet.HeaderType.TO_ADDRESS) > -1;\n\n  /** @type {boolean} */\n  var showFromAddress = headerFields.indexOf(Packet.HeaderType.FROM_ADDRESS) > -1;\n\n  /** @type {boolean} */\n  var showPacketInfo = headerFields.indexOf(Packet.HeaderType.PACKET_INDEX) > -1 &&\n      headerFields.indexOf(Packet.HeaderType.PACKET_COUNT) > -1;\n\n  /** @type {boolean} */\n  var usePacketGranularity = (locals.messageGranularity === MessageGranularity.PACKETS);\n\n  /**\n   * Write the table header to the page, with the appropriate packet-header columns enabled.\n   */\n  function tableHeader() {\n    %>\n      <thead>\n        <tr>\n          <th nowrap class="<%= PacketUIColumnType.ENCODING_LABEL %>"></th>\n          <% if (showToAddress) { %>\n          <th nowrap class="<%= PacketUIColumnType.TO_ADDRESS %>"><%= i18n.to() %></th>\n          <% } %>\n          <% if (showFromAddress) { %>\n          <th nowrap class="<%= PacketUIColumnType.FROM_ADDRESS %>"><%= i18n.from() %></th>\n          <% } %>\n          <% if (showPacketInfo) { %>\n          <th nowrap class="<%= PacketUIColumnType.PACKET_INFO %>"><%= i18n.packet() %></th>\n          <% } %>\n          <th class="<%= PacketUIColumnType.MESSAGE %>">\n            <%= i18n.message() %>\n            <div class="packet-controls">\n              <span class="netsim-button netsim-button-secondary remove-packet-button" title="<%= i18n.removePacket() %>"><i class="fa fa-times"></i></span>\n            </div>\n          </th>\n        </tr>\n      </thead>\n    <%\n  }\n\n  /**\n   * Write a table row to the page for the given data encoding.\n   * @param {EncodingType} encodingType\n   */\n  function editorRow(encodingType) {\n    %>\n      <tr class="<%= encodingType %>">\n        <th nowrap class="<%= PacketUIColumnType.ENCODING_LABEL %>"><%= getEncodingLabel(encodingType) %></th>\n        <% if (showToAddress) { %>\n        <td nowrap class="<%= PacketUIColumnType.TO_ADDRESS %>"><input type="text" class="<%= Packet.HeaderType.TO_ADDRESS %>" /></td>\n        <% } %>\n        <% if (showFromAddress) { %>\n        <td nowrap class="<%= PacketUIColumnType.FROM_ADDRESS %>"><input type="text" readonly class="<%= Packet.HeaderType.FROM_ADDRESS %>" /></td>\n        <% } %>\n        <% if (showPacketInfo) { %>\n        <td nowrap class="<%= PacketUIColumnType.PACKET_INFO %>"><input type="text" readonly class="<%= Packet.HeaderType.PACKET_INDEX %>" /><%= i18n._of_() %><input type="text" readonly class="<%= Packet.HeaderType.PACKET_COUNT %>" /></td>\n        <% } %>\n        <td class="<%= PacketUIColumnType.MESSAGE %>"><div><textarea class="message"></textarea></div></td>\n      </tr>\n    <%\n  }\n%>\n<table>\n  <%\n    // Only write the header row if we are using packets\n    if (usePacketGranularity) {\n      tableHeader();\n    }\n  %>\n  <tbody>\n    <%\n      // Write a body row for every packet encoding; we hide some of them post-render.\n      forEachEnumValue(EncodingType, function (encodingType) {\n        if (isEncodingEnabled(encodingType)) {\n          editorRow(encodingType);\n        }\n      });\n    %>\n  </tbody>\n</table>\n\n<% if (usePacketGranularity) { %>\n  <div class="bit-counter"></div>\n<% } %>\n', __filename = "src/netsim/NetSimPacketEditor.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            var i18n = require("@cdo/netsim/locale");
            var NetSimConstants = require("./NetSimConstants");
            var NetSimUtils = require("./NetSimUtils");
            var Packet = require("./Packet");
            var EncodingType = NetSimConstants.EncodingType;
            var MessageGranularity = NetSimConstants.MessageGranularity;
            var PacketUIColumnType = NetSimConstants.PacketUIColumnType;
            var getEncodingLabel = NetSimUtils.getEncodingLabel;
            var forEachEnumValue = NetSimUtils.forEachEnumValue;
            function isEncodingEnabled(queryEncoding) {
                return locals.enabledEncodingsHash[queryEncoding] === true;
            }
            var headerFields = locals.packetSpec;
            var showToAddress = headerFields.indexOf(Packet.HeaderType.TO_ADDRESS) > -1;
            var showFromAddress = headerFields.indexOf(Packet.HeaderType.FROM_ADDRESS) > -1;
            var showPacketInfo = headerFields.indexOf(Packet.HeaderType.PACKET_INDEX) > -1 && headerFields.indexOf(Packet.HeaderType.PACKET_COUNT) > -1;
            var usePacketGranularity = locals.messageGranularity === MessageGranularity.PACKETS;
            function tableHeader() {
                __line = 43;
                __append('\n      <thead>\n        <tr>\n          <th nowrap class="');
                __line = 46;
                __append(escapeFn(PacketUIColumnType.ENCODING_LABEL));
                __append('"></th>\n          ');
                __line = 47;
                if (showToAddress) {
                    __append('\n          <th nowrap class="');
                    __line = 48;
                    __append(escapeFn(PacketUIColumnType.TO_ADDRESS));
                    __append('">');
                    __append(escapeFn(i18n.to()));
                    __append("</th>\n          ");
                    __line = 49;
                }
                __append("\n          ");
                __line = 50;
                if (showFromAddress) {
                    __append('\n          <th nowrap class="');
                    __line = 51;
                    __append(escapeFn(PacketUIColumnType.FROM_ADDRESS));
                    __append('">');
                    __append(escapeFn(i18n.from()));
                    __append("</th>\n          ");
                    __line = 52;
                }
                __append("\n          ");
                __line = 53;
                if (showPacketInfo) {
                    __append('\n          <th nowrap class="');
                    __line = 54;
                    __append(escapeFn(PacketUIColumnType.PACKET_INFO));
                    __append('">');
                    __append(escapeFn(i18n.packet()));
                    __append("</th>\n          ");
                    __line = 55;
                }
                __append('\n          <th class="');
                __line = 56;
                __append(escapeFn(PacketUIColumnType.MESSAGE));
                __append('">\n            ');
                __line = 57;
                __append(escapeFn(i18n.message()));
                __append('\n            <div class="packet-controls">\n              <span class="netsim-button netsim-button-secondary remove-packet-button" title="');
                __line = 59;
                __append(escapeFn(i18n.removePacket()));
                __append('"><i class="fa fa-times"></i></span>\n            </div>\n          </th>\n        </tr>\n      </thead>\n    ');
                __line = 64;
            }
            function editorRow(encodingType) {
                __line = 72;
                __append('\n      <tr class="');
                __line = 73;
                __append(escapeFn(encodingType));
                __append('">\n        <th nowrap class="');
                __line = 74;
                __append(escapeFn(PacketUIColumnType.ENCODING_LABEL));
                __append('">');
                __append(escapeFn(getEncodingLabel(encodingType)));
                __append("</th>\n        ");
                __line = 75;
                if (showToAddress) {
                    __append('\n        <td nowrap class="');
                    __line = 76;
                    __append(escapeFn(PacketUIColumnType.TO_ADDRESS));
                    __append('"><input type="text" class="');
                    __append(escapeFn(Packet.HeaderType.TO_ADDRESS));
                    __append('" /></td>\n        ');
                    __line = 77;
                }
                __append("\n        ");
                __line = 78;
                if (showFromAddress) {
                    __append('\n        <td nowrap class="');
                    __line = 79;
                    __append(escapeFn(PacketUIColumnType.FROM_ADDRESS));
                    __append('"><input type="text" readonly class="');
                    __append(escapeFn(Packet.HeaderType.FROM_ADDRESS));
                    __append('" /></td>\n        ');
                    __line = 80;
                }
                __append("\n        ");
                __line = 81;
                if (showPacketInfo) {
                    __append('\n        <td nowrap class="');
                    __line = 82;
                    __append(escapeFn(PacketUIColumnType.PACKET_INFO));
                    __append('"><input type="text" readonly class="');
                    __append(escapeFn(Packet.HeaderType.PACKET_INDEX));
                    __append('" />');
                    __append(escapeFn(i18n._of_()));
                    __append('<input type="text" readonly class="');
                    __append(escapeFn(Packet.HeaderType.PACKET_COUNT));
                    __append('" /></td>\n        ');
                    __line = 83;
                }
                __append('\n        <td class="');
                __line = 84;
                __append(escapeFn(PacketUIColumnType.MESSAGE));
                __append('"><div><textarea class="message"></textarea></div></td>\n      </tr>\n    ');
                __line = 86;
            }
            __line = 88;
            __append("\n<table>\n  ");
            __line = 90;
            if (usePacketGranularity) {
                tableHeader();
            }
            __line = 95;
            __append("\n  <tbody>\n    ");
            __line = 97;
            forEachEnumValue(EncodingType, function(encodingType) {
                if (isEncodingEnabled(encodingType)) {
                    editorRow(encodingType);
                }
            });
            __line = 104;
            __append("\n  </tbody>\n</table>\n\n");
            __line = 108;
            if (usePacketGranularity) {
                __append('\n  <div class="bit-counter"></div>\n');
                __line = 110;
            }
            __append("\n");
            __line = 111;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}